import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import moment from "moment";

const UserDetailsModal = ({ viewModal, setViewModal, selectedUser }) => {
  return (
    <Modal show={viewModal} onHide={() => setViewModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedUser && (
          <Row className="g-3">
            <Col xs={12}>
              <p><strong>ID:</strong> {selectedUser.id}</p>
            </Col>
            <Col xs={12}>
              <p><strong>First Name:</strong> {selectedUser.first_name}</p>
            </Col>
            <Col xs={12}>
              <p><strong>Mobile No:</strong> {selectedUser.mobile_no}</p>
            </Col>
            <Col xs={12}>
              <p><strong>Email:</strong> {selectedUser.email}</p>
            </Col>
            <Col xs={12}>
              <p>
                <strong>Created At:</strong> {moment(new Date(selectedUser.created_at)).format("DD-MM-YYYY h:mm a")}
              </p>
            </Col>
            {/* <Col xs={12}>
              <p>
                <strong>Updated At:</strong> {moment(new Date(selectedUser.updated_at)).format("DD-MM-YYYY h:mm a")}
              </p>
            </Col> */}
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button style={{backgroundColor:"#e8783d",border:"none"}} onClick={() => setViewModal(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserDetailsModal;
